"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useCheckAll = function useCheckAll() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var onChange = arguments.length > 1 ? arguments[1] : undefined;

  // Checked items
  var _useState = (0, _react.useState)(options.filter(function (item) {
    return !!item.checked;
  })),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      allCheckedList = _useState2[0],
      setAllCheckedList = _useState2[1]; // Need to filter allCheckedList with options
  // because some of the options may be deleted.


  var checkedList = (0, _react.useMemo)(function () {
    return allCheckedList.filter(function (item) {
      return options.some(function (option) {
        return item.id === option.id;
      });
    });
  }, [allCheckedList, options]); // If check all items

  var checkAll = (0, _react.useMemo)(function () {
    return checkedList.length === options.length;
  }, [checkedList, options]);
  var indeterminate = (0, _react.useMemo)(function () {
    // Should check indeterminate when options are changed
    return checkedList.length < options.length && checkedList.length > 0;
  }, [checkedList.length, options.length]); // Handle check one item

  var handleChange = (0, _react.useCallback)(function (e) {
    var list = [];
    var _e$target = e.target,
        checked = _e$target.checked,
        id = _e$target.id;

    if (checked) {
      list = [].concat((0, _toConsumableArray2["default"])(checkedList), [options.find(function (item) {
        return item.id === id;
      })]);
    } else {
      list = checkedList.filter(function (item) {
        return item.id !== id;
      });
    }

    setAllCheckedList(list);
    onChange(list);
  }, [checkedList, options, onChange]); // Handle select all

  var handleCheckAllChange = (0, _react.useCallback)(function (e) {
    setAllCheckedList(e.target.checked ? options : []);
    onChange(e.target.checked ? options : []);
  }, [options, onChange]);
  return {
    indeterminate: indeterminate,
    checkAll: checkAll,
    checkedList: checkedList,
    handleCheckAllChange: handleCheckAllChange,
    handleChange: handleChange
  };
};

var _default = useCheckAll;
exports["default"] = _default;
//# sourceMappingURL=useCheckAll.js.map